<div class="create-location-wrapper" [ngClass]="cssClass">
    <div class="create-location"
         [ngClass]="{ 'create-location--margin' : showMargin, 'create-location--fluent' : fluentRefresh }">
        <span class="create-location__prompt"
              [ngClass]="{'ms-fcl-ns' : !fluentRefresh, 'ms-fcl-np' : fluentRefresh }"
        >{{ createLocationPrompt }}</span>
        <ohp-icon-font size="16" [color]="oneDriveColor" cssClass="ms-ohp-svg-Icon ms-ohp-Icon--oneDriveLogo create-location__icon"></ohp-icon-font>
        <span class="create-location__path"
              [ngClass]="{'ms-fcl-ns' : !fluentRefresh, 'ms-fcl-np' : fluentRefresh }"
              [innerHTML]="createLocation"></span>
    </div>
</div>
